import { render, staticRenderFns } from "./ChatRight.vue?vue&type=template&id=fa79a8a0&scoped=true&"
import script from "./ChatRight.vue?vue&type=script&lang=js&"
export * from "./ChatRight.vue?vue&type=script&lang=js&"
import style0 from "./ChatRight.vue?vue&type=style&index=0&id=fa79a8a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa79a8a0",
  null
  
)

export default component.exports